import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getAirwaySelector } from '../selectors'
import { setAddToTimeLine } from '../store/airway.actions'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { addAirwayItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveAirway() {
  const airwayStateWithDefaults: IAirwayState = yield select(getAirwaySelector)
  let airwayState: IAirwayState = {
    ...airwayStateWithDefaults,
    airwayDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    airwayState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: airwayState,
      actionField: (s) => s.action.name,
      filter1Field: (s) => s.pressure, // pressure (any value)
      filter2Field: (s) => s.inspiratoryPressure, // inspiratory pressure (any value)
      filter3Field: (s) => s.expiratoryPressure, // expiratory pressure (any value)
      nemsisCodeOptions,
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: unknown) {
    airwayState = handleNemsisCodeError(error, airwayState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.airwayStateList && pcrDoc.patient?.airwayStateList.length) {
    const index = pcrDoc.patient?.airwayStateList?.findIndex((airway) => airway.key === airwayState.key)
    if (index !== -1) {
      pcrDoc.patient.airwayStateList[index] = airwayState
    } else {
      pcrDoc.patient?.airwayStateList.push(airwayState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, airwayStateList: [airwayState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addAirwayItem())
  } catch (e) {
    yield put(throwPcrException(`saveAirway() error: ${e}`))
  }
}

export function* saveAirwaySaga() {
  yield takeLatest(
    [
      AirwayConstants.SAVE_AIRWAY,
      AirwayConstants.SET_DATE,
      AirwayConstants.SET_TIME,
      AirwayConstants.SET_DATE_TIME,
      AirwayConstants.SET_ASSESSED_BY,
      AirwayConstants.SET_RESPONSE,
      AirwayConstants.SET_RESPONSE_PNNV,
      AirwayConstants.SET_PROCEDURE_COMPLICATIONS,
      AirwayConstants.SET_AUTHORIZATION,
      AirwayConstants.SET_AIRWAY_COMPLICATIONS,
      AirwayConstants.SET_AIRWAY_COMPLICATIONS_PNNV,
      AirwayConstants.SET_VERIFICATION_METHOD,
      AirwayConstants.SET_ATTEMPTS,
      AirwayConstants.SET_ROLE_PERFORMING,
      AirwayConstants.SET_ROLE_PERFORMING_PNNV,
      AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      AirwayConstants.SET_PTA,
      AirwayConstants.SET_REASONS_FOR_FAILURE,
    ],
    performWithMutexHOG,
    saveAirway
  )
}
